"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Icon = function Icon(props) {
  var iconName = props.iconName,
      iconColor = props.iconColor,
      iconSize = props.iconSize,
      iconType = props.iconType;
  var style = {
    fontSize: iconSize,
    color: iconColor
  };
  var icon = null;

  if (iconType === "Material") {
    icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      fontSize: "inherit"
    }, iconName);
  } else if (iconType === "FontAwesome") {
    icon = /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: iconName
    });
  }

  return /*#__PURE__*/_react["default"].createElement("i", {
    style: style
  }, icon);
};

Icon.propTypes = {
  iconName: _propTypes["default"].string,
  iconColor: _propTypes["default"].string,
  iconType: _propTypes["default"].string,
  iconSize: _propTypes["default"].number
};
Icon.defaultProps = {
  iconName: "",
  iconColor: "",
  iconType: "FontAwesome",
  iconSize: 24
};
var _default = Icon;
exports["default"] = _default;